// extracted by mini-css-extract-plugin
export default {"Failure":"_Failure--aM2XN","DocumentViewPositioning":"_DocumentViewPositioning--V9knl","SingleColumn":"_SingleColumn--g8VzO","SupportEmail":"_SupportEmail--t0hG5"};